import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useSelector } from 'react-redux';
import useTracking from 'hooks/useTracking';
import { getVerificationPrompt } from 'data/api';
import { ROOT_URL, USERS_VERIFICATION_URL } from 'constants/routes';
import { VerificationMethods } from 'constants/verification';
import { urlWithParams } from 'libs/utils/url';
import { abTestExposeEvent } from 'libs/common/event-tracker/events';
import { getAbTestByName } from 'state/ab-tests/selectors';
import { getExposee } from 'state/session/selectors';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import useSuccessUrl from './useSuccessUrl';
export const useEmailCodeTest = () => {
  const isEmailCodeTestEnabled = useSelector(getIsFeatureSwitchEnabled('email_verification_new_users_test'));
  const abTest = useSelector(getAbTestByName('non_skippable_email_verification_new_users'));
  const exposee = useSelector(getExposee);
  const successUrl = useSuccessUrl(ROOT_URL);
  const {
    track
  } = useTracking();

  const handleEmailCodeTest = async userId => {
    if (!isEmailCodeTestEnabled) return undefined;
    const response = await getVerificationPrompt(userId);
    if ('errors' in response) return undefined;
    if (abTest) track(abTestExposeEvent(_objectSpread(_objectSpread({}, exposee), abTest)));
    if (!response.prompt.methods.includes(VerificationMethods.EmailCode)) return undefined;
    return urlWithParams(USERS_VERIFICATION_URL, {
      ref_url: successUrl
    });
  };

  return {
    handleEmailCodeTest
  };
};